/** @format */
import { h } from 'vue';
import { useBaseConfigStoreWithOut } from '../../config/widget';
const modules = import.meta.glob('./*.vue', { eager: true });

const comps = {};

for (const [path, module] of Object.entries(modules)) {
	const name = path.replace(/(\.\/|\.vue)/g, '');
	// @ts-ignore
	comps[name] = module.default;
}

const getWidgetName = (type: string, name?: string) => {
	const baseConfigStore = useBaseConfigStoreWithOut(name);
	const components = { ...comps, ...baseConfigStore.FIELDS_COMPONENTS };
	if (!components[`${type}`]) {
		console.error('没有该类型组件');
		return h('div');
	} else {
		return components[`${type}`];
	}
};

export { comps, getWidgetName };
